export default __webpack_public_path__ + "static/media/Apple_wallet_icon.791c72b0.svg";